export class PhoneInUseError extends Error {
  constructor() {
    super('Telefone já cadastrado')
    this.name = 'PhoneInUseError'
  }
}
